export enum GoogleAnalyticsEvents {
  timingComplete = 'timing_complete',
  search = 'search',
  pageView = 'page_view',
}

export enum GoogleAnalyticsProperties {
  userProperties = 'user_properties',
}
